var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-modal",class:{
    'is-active': _vm.isActive,
    'centered': _vm.centered
  }},[_c('a',{staticClass:"delete is-large",on:{"click":_vm.close}}),_c('div',{staticClass:"container overflow-auto fancy-scrollbar"},[_c('div',{staticClass:"inner-container"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }